import React from 'react';
import { useLang, useT, Lang, LANGUAGES } from '../i18n';

interface Props {
  // appelé en plus de setLang (ex: persister côté compte dans l'admin)
  onChange?: (lang: Lang) => void;
  className?: string;
}

// Choix de la langue : petit menu déroulant discret (« FR ▾ »).
const LanguageSwitch: React.FC<Props> = ({ onChange, className }) => {
  const { lang, setLang } = useLang();
  const t = useT();
  return (
    <select
      className={`mk-lang ${className || ''}`}
      aria-label={t('Langue')}
      value={lang}
      onChange={(e) => {
        const l = e.target.value as Lang;
        setLang(l);
        onChange?.(l);
      }}
    >
      {LANGUAGES.map((l) => (
        <option key={l.code} value={l.code} lang={l.code} title={l.label}>
          {l.code.toUpperCase()}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitch;
